(ns kyber.components.composite.gdpr-splash
  (:require [kyber.components.base.text :as text]
            [kyber.styles.core :refer [gs]]
            [kyber.i18n.core :as i18n]))

(defn render
  [{:keys [color]
    :or {color (gs [:colors :true-white])}}]
  [:div
   [text/caption-20 :p {:style {:color color}}
    (i18n/t* ::disclaimer)]
   [text/caption-20 :p {:style {:color color}
                        :href "https://www.archemedx.com/privacy-policy/"}
    [:a {:href "https://www.archemedx.com/privacy-policy/"
         :target "_blank"
         :style {:color color}}
     (i18n/t* ::policy)]]])
